class MidiBinder {

	constructor() {
		this.bindings = new Map();
	}

	rehydrate(state) {
		this.bindings = new Map(state.bindings || []);
	}

	dehydrate() {
		this.bindings.forEach((value, key) => {
			if(value.length == 0) {
				this.bindings.delete(key);
			}
		});

		return {
			bindings: Array.from(this.bindings.entries())
		};
	}

	add(midiData, path) {
		var arr = this.bindings.has(midiData.midi_path) ? this.bindings.get(midiData.midi_path) : [];

		arr.push({
			path: path,
			type: midiData.midi_type,
			channel: midiData.midi_channel,
			device: midiData.midi_device,
			number: midiData.midi_number
		});

		this.bindings.set(midiData.midi_path, arr);
	}

	remove(midi_path, path) {
		if(this.bindings.has(midi_path)) {
			var arr = this.bindings.get(midi_path);

			arr = arr.filter(function(item){
				return item.path != path;
			});

			this.bindings.set(midi_path, arr);
		}
	}
}

export default MidiBinder;
